const SNOOZE_EXPIRY_STORAGE_KEY =
  'portainer.policies.change-confirmation-snooze-timeout';

/** Maximum snooze duration in minutes (8 hours) */
export const MAX_SNOOZE_MINUTES: SnoozeDurationMinutes = 480;

/** Preset snooze durations in minutes */
export const SNOOZE_DURATION_OPTIONS_MINUTES = [
  15, 30, 60, 120, 240, 480,
] as const;
export type SnoozeDurationMinutes =
  (typeof SNOOZE_DURATION_OPTIONS_MINUTES)[number];

function parseSnoozeTimeout(
  snoozeExpiryTimestampRaw: string | null
): number | null {
  if (
    snoozeExpiryTimestampRaw === null &&
    typeof snoozeExpiryTimestampRaw !== 'number'
  ) {
    return null;
  }
  return Number(snoozeExpiryTimestampRaw);
}

export function isSnoozeActive(): boolean {
  const snoozeExpiryTimestampRaw = localStorage.getItem(
    SNOOZE_EXPIRY_STORAGE_KEY
  );
  if (!snoozeExpiryTimestampRaw) return false;
  const snoozeExpiryTimestamp = parseSnoozeTimeout(snoozeExpiryTimestampRaw);
  return snoozeExpiryTimestamp !== null && Date.now() < snoozeExpiryTimestamp;
}

/**
 * Saves a snooze expiry timestamp to localStorage
 */
export function setSnooze(minutes: SnoozeDurationMinutes): void {
  const snoozeDurationMinutes = Math.min(minutes, MAX_SNOOZE_MINUTES);
  const snoozeExpiryTimestamp = Date.now() + snoozeDurationMinutes * 60 * 1000;
  localStorage.setItem(
    SNOOZE_EXPIRY_STORAGE_KEY,
    String(snoozeExpiryTimestamp)
  );
}

export function clearSnooze(): void {
  localStorage.removeItem(SNOOZE_EXPIRY_STORAGE_KEY);
}
